import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

export interface PartPaymentWidgetResponse {
  token: string
  url: string
  minPayment: number
  maxPayment: number
}

export const getPartPaymentWidget = async <T = any>(args: {
  apiConfigs: APIConfig
  channelId: string
  onSuccess: (response: { data: PartPaymentWidgetResponse }) => T
}): Promise<T> => {
  const { channelId, onSuccess } = args
  const { skbvApiBaseUrl } = args.apiConfigs

  return await axios<PartPaymentWidgetResponse>({
    method: 'get',
    url: `${skbvApiBaseUrl}/Payment/PartPaymentProviderWidget?channelId=${channelId}`,
  })
    .then(async (response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
